import { Link } from 'found'
import posed from 'react-pose'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import Shopify from '../../shopify'

const Posed = posed.div({
    hoverable: true,
    init: { opacity: 0, transition: { duration: 1000 } },
    hovered: { opacity: 1, transition: { duration: 1000 } }
})

class ProductPreview extends Component {
    componentDidMount() {
        setTimeout(() => {
            if (this.props.name.indexOf('(Pre-order)') !== -1) {
                let buttons = document.querySelectorAll("div[id^='" + this.props.buttonId + "'] button")

                for (let b of buttons) {
                    b.innerHTML = 'PRE-ORDER'
                    b.style.width = '65px';
                    b.style['letter-spacing'] = '0px';
                    b.style.padding = '0px';
                }
            }
        }, 2000)
        // set el height and width etc.
    }

    constructor() {
        super()
        this.state = {
            hovering: false,
            isHoveringView: false,
            isHoveringBuy: false,
        }
    }

    render() {
        const { noMargin, link, picture, price, color, buttonId } = this.props
        let marginClass = noMargin ? 'no-margin-left' : ''

        return (
            <div className={`books-row ${marginClass} w-col w-col-3 w-col-medium-6`}>
                <div
                    className="books-actions"
                    onMouseEnter={() => this.setState({ hovering: true })}
                    onMouseLeave={() => this.setState({ hovering: false })}
                >
                    <Link to={link} className="store-book-container w-inline-block">
                        <img alt="" src={picture} className="book" />
                    </Link>
                    <Posed pose={this.state.hovering ? "hovered" : "init"}>
                        <div className="extrainfo w-hidden-medium w-hidden-small w-hidden-tiny">
                            <div className="div-block-66">
                                <Link to={link} className="view w-button" style={{ borderColor: color }}>
                                    VIEW
                                </Link>
                                <div className="addtobasket aarhus-color w-inline-block">
                                    <div id={buttonId} />
                                    <div className="price">€{price}</div>
                                </div>
                            </div>
                            <div style={{ background: color }} className="bk-color-books aarhus_color" />
                        </div>
                    </Posed>
                </div>
                <div data-w-id="bc4a7127-1df6-bddb-e61d-82bce31d325c" className="extrainfo-mobile w-hidden-main">
                    <div className="div-block-66">
                        <Link
                            to={link}
                            onMouseEnter={() => this.setState({ isHoveringView: true })}
                            onMouseLeave={() => this.setState({ isHoveringView: false })}
                            className="view aarhus-color w-button"
                            style={{
                                borderColor: color,
                                backgroundColor: this.state.isHoveringView ? color : '#FFFFFF',
                            }}
                        >
                            VIEW
                        </Link>
                        <div
                            onMouseEnter={() => this.setState({ isHoveringBuy: true })}
                            onMouseLeave={() => this.setState({ isHoveringBuy: false })}
                            className="addtobasket aarhus-color w-inline-block"
                            style={{
                                borderColor: color,
                                backgroundColor: this.state.isHoveringBuy ? color : '#FFFFFF',
                            }}
                        >
                            <div id={buttonId + '-mobile'} />
                            <div className="price" style={{ background: color + '51' }}>
                                €{price}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const connectRelay = ProductPreview => class extends Component {

    componentDidMount() {
        const options = {
            "cart": {
                "popup": false,
                "text": { "currency": "EUR" },
                "styles": {
                    "button": { "background-color": "red" }
                }
            },
            "product": {
                "iframe": false,
                "templates": {
                    "button": '<div style="padding-left: 22px; padding-right: 22px;" data-element="product.buttonWrapper"><button style="background: none;" {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="text-block-3" data-element="product.button">{{data.buttonText}}</button></div>'
                },
                "text": {
                    "button": "BUY",
                },
                "contents": {
                    "img": false,
                    "imgWithCarousel": false,
                    "title": false,
                    "variantTitle": false,
                    "price": false,
                    "description": false,
                    "buttonWithQuantity": false,
                    "quantity": false,
                    "footer": false,
                },
                "classes": {
                    "wrapper": 'button small secondary w-inline-block',
                    "button": 'text-block-3',
                },
                "styles": {
                }
            },
        }

        Shopify.createComponent('product', {
            id: [this.props.product.shopifyProduct],
            node: document.getElementById('product-' + this.props.product.shopifyProduct),
            options
        }).then(product => this.setState({ product }))

        Shopify.createComponent('product', {
            id: [this.props.product.shopifyProduct],
            node: document.getElementById('product-' + this.props.product.shopifyProduct + '-mobile'),
            options
        })
    }

    getPrice = (product) => {
        const d = parseFloat(product.selectedVariant.price.amount)
        const r = Math.round(d)
        return d === r ? r : d
    }

    render() {
        const { routeResolver } = this.props.context
        const { product } = this.props
        const props = {
            noMargin: this.props.noMargin,
            link: routeResolver.product.get(product.slug),
            name: product.name,
            picture: product.picture,
            color: product.city.color,
            buttonId: 'product-' + this.props.product.shopifyProduct,
            price: this.state && this.state.product ? this.getPrice(this.state.product) : '',
        }

        return <ProductPreview {...props} />
    }
}

export default createFragmentContainer(
    connectRelay(ProductPreview),
    graphql`
        fragment productPreview_product on Product {
            slug
            name
            picture
            shopifyProduct
            city {
                color
            }
        }
    `
)
